module.exports = __webpack_public_path__ + "static/img/icon_dbss.ada30110.png";